import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { VendorQuarterlyFeedbackComponent } from './vendor-quarterly-feedback.component';
import { VendorQuarterlyFeedbackService } from './vendor-quarterly-feedback.service';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { RouterModule } from '@angular/router';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';

@NgModule({
  declarations: [
    VendorQuarterlyFeedbackComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    EmeraldButtonModule,
    EmeraldInputModule,
    EmeraldIconModule,
    EmeraldDropdownModule,
    RouterModule,
    FileUploadComponent
  ],
  exports: [
    VendorQuarterlyFeedbackComponent
  ],
  providers: [
    VendorQuarterlyFeedbackService
  ]
})
export class VendorQuarterlyFeedbackModule { }
